import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { ActionEntry } from "../../ActionEntries";

export const meetsCostRequirements = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
) => {
  // Validate if costs for action can be met
  for (let i = 0; i < action.cost.length; i++) {
    const trueCost =
      action.cost[i].baseChangeValue + action.costIncrement * action.costScale;
    const currBrick = newBricks.get(action.cost[i].brickId);

    // If brick doesn't exist or amount is NaN, cost requirements are not met
    if (
      !currBrick ||
      Number.isNaN(currBrick.amount) ||
      currBrick.amount < trueCost
    )
      return false;
  }

  return true;
};
